import generalTypes from './types';

export const initialStates = {
	apiStatus: {
		loading: {},
	},
};

const generalReducers = (state = initialStates, action) => {
	switch (action.type) {
		case generalTypes.API_STATUS.LOADING.START:
			return {
				...state,
				apiStatus: {
					loading: {
						...state.apiStatus.loading,
						...{ [action.payload]: 'true' },
					},
				},
			};

		case generalTypes.API_STATUS.LOADING.STOP: {
			const queue = { ...state.apiStatus.loading };
			delete queue[action.payload];
			return {
				...state,
				apiStatus: {
					loading: { ...queue },
				},
			};
		}

		default:
			return state;
	}
};

export default generalReducers;
